/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react'
import { Pane, majorScale } from 'evergreen-ui'
import { useQuery } from '@apollo/react-hooks'
import gql from 'graphql-tag'
import useWorkspace from 'hooks/use-workspace'
import Page from '../components/Page'
import TopBar from '../components/TopBar'
import CatalogNavigationBar from './ListPage/CatalogNavigationBar'
import Maintenance from '../components/Maintenance'

const WRAPPER_QUERY = gql`
  query FunctionsWrapper($workspaceSlug: Slug!) {
    workspace(slug: $workspaceSlug) {
      id
      isMigrated: flagon(family: "destination-functions", name: "v2-available")
    }
  }
`

const WrapperPage = (component: any): React.FC => (props: any) => {
  const { workspace } = useWorkspace()
  const { data, loading, error } = useQuery(WRAPPER_QUERY, {
    variables: {
      workspaceSlug: workspace!.slug
    }
  })

  const isLoaded = !loading && !error

  return (
    <>
      {isLoaded && (
        <>
          {data.workspace.isMigrated ? (
            React.createElement(component, props)
          ) : (
            <Page title="Functions">
              <Pane>
                <TopBar title="Catalog" />
                <CatalogNavigationBar />

                <Pane paddingTop={majorScale(8)}>
                  <Maintenance />
                </Pane>
              </Pane>
            </Page>
          )}
        </>
      )}
    </>
  )
}

export default WrapperPage
